var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',[_c('h1',[_vm._v("DAIDAIDAI")]),_c('h3',[_vm._v(_vm._s(_vm.document.data.title[0].text))]),_c('SliceZone',{attrs:{"slices":_vm.document.data.body,"resolver":function (ref) {
	var sliceName = ref.sliceName;

	return _vm.slices[sliceName];
}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }